// extracted by mini-css-extract-plugin
export default {"setting-list-box":"MyDataViewSetting_setting-list-box__bjhjr"};